import WixSDK from 'shared/utils/wix-sdk';
import bi from 'shared/bi/bi';
import requestLoginModes from 'shared/constants/request-login-modes';

const systemEventsPerLoginMode = {
  [requestLoginModes.SIGN_UP]: {
    requested: 'user.signup.requested',
    succeeded: 'user.signup.succeeded',
    cancelled: 'user.signup.cancelled',
  },
  [requestLoginModes.LOGIN]: {
    requested: 'user.logIn.requested',
    succeeded: 'user.logIn.succeeded',
    cancelled: 'user.logIn.cancelled',
  },
};

const requestAuth = isLogin => {
  const mode = isLogin ?
    requestLoginModes.LOGIN :
    requestLoginModes.SIGN_UP;

  const systemEvents = systemEventsPerLoginMode[mode];

  bi.logWidgetSystem(systemEvents.requested);

  return new Promise((resolve, reject) => {
    const onLogin = loggedInUserData => {
      if (loggedInUserData.authResponse) {
        bi.logWidgetSystem(systemEvents.succeeded, {
          previousEventName: systemEvents.requested,
        });
        resolve(loggedInUserData);
      }
    };

    const onError = error => {
      if (_.get(error, 'wasCancelled')) {
        bi.logWidgetSystem(systemEvents.cancelled, {
          previousEventName: systemEvents.requested,
        });
        return;
      }
      reject(error);
    };

    WixSDK.requestLogin(
      {
        language: WixSDK.Utils.getLocale(),
        mode,
      },
      onLogin,
      onError
    );
  });
};

export const requestLogin = () => requestAuth(true);
export const requestSignUp = () => requestAuth(false);
export const logOutCurrentMember = () => {
  bi.logWidgetSystem('user.logOut.requested');
  WixSDK.logOutCurrentMember();
};



// WEBPACK FOOTER //
// ./src/shared/utils/auth.js